import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { btnPrimary, eyebrow } from './WaLink';
import { services } from '../data/salon';

const aboutPhoto = 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/41bfc460d9e6c0e2399fe8dbd78f9816.webp';
const glowPhoto = 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/665cc4cc7a0c21dd513cc05db148e6e1.webp';
const treatmentPhoto = 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/2a07b90985e7c7d6cd5d1016752bab0f.webp';

function Marquee() {
  const items = [...services, ...services];
  return (
    <div className="overflow-hidden bg-[#0B3B36] py-5 text-[#FBF5EA]" aria-hidden="true">
      <div className="marquee-track">
        {items.map((s, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display text-2xl italic">
            {s.name} <span className="text-[#E9A23B]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}

function About() {
  return (
    <section id="about" className="mx-auto grid max-w-[1280px] items-center gap-10 px-4 py-20 sm:px-6 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
      <div className="order-2 lg:order-1">
        <span className={eyebrow}>About our salon</span>
        <h2 className="font-display mt-4 text-4xl leading-tight text-[#0B3B36] sm:text-5xl">
          A calm, caring space for <em className="text-[#C8553D]">every look.</em>
        </h2>
        <p className="mt-5 max-w-md text-[#4b5d59]">Trusted by families in Agra for hygienic, personal beauty care.</p>
        <div className="mt-6 flex items-center gap-4 rounded-xl bg-[#E4EDE6] p-5">
          <SafeIcon icon={FiIcons.FiShield} className="text-3xl text-[#0B3B36]" />
          <p className="font-display text-lg text-[#0B3B36]">Clean tools. Gentle hands. Honest advice.</p>
        </div>
        <WaLink className={`${btnPrimary} mt-7`}>Say hello <SafeIcon icon={FiIcons.FiArrowUpRight} /></WaLink>
      </div>
      <div className="order-1 grid grid-cols-2 gap-3 lg:order-2">
        <img src={aboutPhoto} alt="Salon styling" className="h-[420px] w-full rounded-2xl object-cover" />
        <div className="grid gap-3">
          <img src={glowPhoto} alt="Glowing skin" className="h-[204px] w-full rounded-2xl object-cover object-[center_30%]" />
          <img src={treatmentPhoto} alt="Salon treatment" className="h-[204px] w-full rounded-2xl object-cover object-[center_30%]" />
        </div>
      </div>
    </section>
  );
}

export { Marquee, About };
